import React from "react";
import "./App.css";
import { Viewer, CzmlDataSource } from "resium";
import { czml } from "./czml";
import "./App.css";
import Controller from "./components/Controller";
import News from "./components/News";
import Modal from "react-modal";
import ReactGA from "react-ga4";

Modal.setAppElement("#root");

const App = () => {
  return (
    <div>
      <header>SpaceEye Console</header>
      <div className="description">
        <p>
          軌道上撮影プラットフォーム<strong>Space Eye</strong>。{" "}
          誰でも宇宙空間から写真撮影ができます。
        </p>
        <p>
          宇宙の光景の力はときに人生観を変えるほど。 あなたにもそんな一枚を。
        </p>
      </div>
      <div id="container">
        <Controller />
        <div id="viewer">
          <h3>SpaceEye人工衛星 現在地</h3>
          <Viewer
            onClick={() => {
              ReactGA.event({
                category: "cesium",
                action: "click",
                label: "viewer",
              });
            }}
            id="cesium"
            className="cesium"
          >
            <CzmlDataSource
              onClick={() => {
                ReactGA.event({
                  category: "cesium",
                  action: "click",
                  label: "satellite",
                });
              }}
              data={czml()}
            />
          </Viewer>
        </div>
        <News />
      </div>
      <footer
        style={{
          textAlign: "center",
          width: "100vw",
          background: "white",
          color: "black",
        }}
      >
        <span>
          運営: <a href="https://jinsei.space/">合同会社尽星</a>
        </span>
        <span>
          Web制作: <a href="https://twitter.com/tannakaken">tannakaken</a>
        </span>
      </footer>
    </div>
  );
};

export default App;
